import {
  NEXT_PUBLIC_SUPABASE_URL,
  NEXT_PUBLIC_SUPABASE_ANON_KEY,
} from '../settings';
import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  NEXT_PUBLIC_SUPABASE_URL,
  NEXT_PUBLIC_SUPABASE_ANON_KEY
);

export const hasAccessOnNewPlatform = async (email) => {
  const { data: user } = await supabase
    .from('users')
    .select('id')
    .eq('email', email)
    .maybeSingle()
    .throwOnError();

  if (!user) return false;

  const { data: participation } = await supabase
    .from('participation')
    .select('*')
    .eq('user_id', user.id)
    .eq('status', 'active')
    .gt('current_period_end', new Date().toISOString())
    .throwOnError();

  return participation.length > 0;
};

export const hasExpiredOnNewPlatform = async (email) => {
  const { data: user } = await supabase
    .from('users')
    .select('id')
    .eq('email', email)
    .maybeSingle()
    .throwOnError();

  if (!user) return null;

  const { data: activeParticipation } = await supabase
    .from('participation')
    .select('*')
    .eq('user_id', user.id)
    .eq('status', 'active')
    .gt('current_period_end', new Date().toISOString())
    .throwOnError();

  if (activeParticipation.length > 0) return false;

  const { data: participation } = await supabase
    .from('participation')
    .select('*')
    .eq('user_id', user.id)
    .throwOnError();

  return participation.length > 0 ? true : null;
};

export const getBillingOnNewPlatform = async (email) => {
  const { data: user } = await supabase
    .from('users')
    .select('id')
    .eq('email', email)
    .maybeSingle()
    .throwOnError();

  if (!user) return false;

  // eslint-disable-next-line no-undef
  const [purchasesRes, subscriptionRes] = await Promise.all([
    supabase
      .from('challenge_interests')
      .select(
        `
      *,
      challenge:challenges (
        title,
        slug
      )
    `
      )
      .eq('user_id', user.id),
    supabase
      .from('subscriptions')
      .select('*')
      .eq('user_id', user.id)
      .maybeSingle(),
  ]);

  if (purchasesRes.error) {
    throw purchasesRes.error;
  }

  if (subscriptionRes.error && subscriptionRes.error.code !== 'PGRST116') {
    throw subscriptionRes.error;
  }

  if (
    subscriptionRes &&
    subscriptionRes.data &&
    subscriptionRes.data.price_id
  ) {
    const { data: pricingPlan } = await supabase
      .from('pricing_plans')
      .select('*')
      .eq('stripe_price_id', subscriptionRes.data.price_id)
      .maybeSingle()
      .throwOnError();
    subscriptionRes.data.pricing_plan = pricingPlan;
  }

  return {
    purchases: purchasesRes.data || [],
    subscription: subscriptionRes.data,
  };
};
